export default __webpack_public_path__ + "static/media/Banner3.29628c39.jpg";